module.exports = __webpack_public_path__ + "img/henry-fox-talbot.366deadd.png";